import React from 'react';
import './Testimonios.css';
import testimonioJaime from '../assets/images/testimonio-jaime.png';
import testimonioElsa from '../assets/images/testimonio-elsa.png';

const Testimonios = () => {
  const testimonios = [
    {
      imagen: testimonioJaime,
      texto: "Un equipo increíble que hizo que todo fuera fácil, seguro y sin complicaciones",
      autor: "Jaime Gatica",
      alt: "Jaime Godoy"
    },
    {
      imagen: testimonioElsa,
      texto: "Nunca pensé que volvería a sonreír con confianza, ahora disfruto de mi sonrisa todos los días",
      autor: "Elda Mura",
      alt: "Elda Mura"
    },
    {
      imagen: "/assets/images/eva-suarez.png",
      texto: "Después de mi cirugía, hasta dormir se transformó en algo distinto.",
      autor: "Eva Suárez",
      alt: "Eva Suárez"
    },
    {
      imagen: "/assets/images/marcela-andrade.png",
      texto: "En CAIMA me guiaron durante todo el proceso y me sentí muy acompañada.",
      autor: "Marcela Andrade",
      alt: "Marcela Andrade"
    },
    {
      imagen: "/assets/images/Vannessa-Diaz.png",
      texto: "Todo mi círculo estaba muy pendiente, a todos les gusto y dicen que no se nota.",
      autor: "Vannessa Díaz",
      alt: "Vannessa Díaz"
    },
    {
      imagen: "/assets/images/Sergio-Varela.png",
      texto: "Excelente atención profesional.",
      autor: "Sergio Varela",
      alt: "Sergio Varela"
    }
  ];

  const renderTestimonioCard = (testimonio) => (
    <div className="testimonio-card">
      <div className="testimonio-imagen">
        <img src={testimonio.imagen} alt={testimonio.alt} />
      </div>
      <div className="testimonio-contenido">
        <p className="testimonio-texto">
          "{testimonio.texto}"
        </p>
        <p className="testimonio-autor">{testimonio.autor}</p>
      </div>
    </div>
  );

  return (
    <section className="testimonios">
      <div className="testimonios-container">
        <div className="testimonios-scroll">
          {testimonios.map((testimonio, index) => (
            <React.Fragment key={`original-${index}`}>
              {renderTestimonioCard(testimonio)}
            </React.Fragment>
          ))}
          {testimonios.map((testimonio, index) => (
            <React.Fragment key={`duplicate-${index}`}>
              {renderTestimonioCard(testimonio)}
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonios; 